import { FC, useContext, useEffect, useState } from "react";
import styles from "./styles.module.scss";
import { Popup, Video } from "components";
import { Button } from "@progress/kendo-react-buttons";
import { Loader } from "@progress/kendo-react-indicators";
import { useAppDispatch } from "hooks";
import { setPageType, setPageTitle } from "store";
import { PageType } from "types";
import { TextArea } from "@progress/kendo-react-inputs";
import { SettingsContext } from "context";

const { BlobBaseUrl } = window.config;

const CONTEXT = `
Mina: Thank you for calling Ralph Lauren! This is Mina, how may I help you?\n
Rupesh: Hi, this is Rupesh. I had purchased a Large sized polo shirt from your online website. But I need to return it as I needed a Medium size. Your online website shows that you are out of stock for the Medium sizes of that polo.\n
Mina: Sorry to hear that the size does not work for you Rupesh. Can you please share your order number?\n
Rupesh: Sure, it is 910019\n
Mina: Thanks! I found your order. We can process your refund. However, my system dies show me that there is one Medium size of the same polo shirt available for pickup at our Fashion Island store which is about 1.5 miles from you. Would you like me to put that on hold for you?\n
Rupesh: Yes! That would be fantastic!\n
Mina: Great! I have put it on hold for 3 days for you. Just take your current polo shirt and receipt with you to that store and they will be happy to exchange it for you. Is there anything else I can help you with?\n
Rupesh: No, but wow! You totally rock! Appreciate going the extra mile for me to find the medium size I needed.\n
Mina: My pleasure sir, have a wonderful rest of the day!\n
Rupesh: You too!\n
  `;

export const CallCenterRalph: FC = () => {
  const dispatch = useAppDispatch();
  const [visible, setVisible] = useState(true);
  const [isEnded, setIsEnded] = useState(false);
  const [summary, setSummary] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const { currentDemo } = useContext(SettingsContext);

  const getSummary = () => {
    setIsLoading(true);

    let myHeaders = new Headers();
    myHeaders.append("api-key", "01fd4995e24c40e0803b59fa7dc20d51");
    myHeaders.append("Content-Type", "application/json");

    let raw = JSON.stringify({
      prompt: CONTEXT + "Create a summary of the conversation.",
      temperature: 0.9,
      max_tokens: 1200,
    });

    let requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
    };

    return fetch(
      "https://healthcare2test.openai.azure.com/openai/deployments/clinical-notes/completions?api-version=2022-12-01",
      requestOptions
    )
      .then((response) => response.json())
      .then((result) => setSummary(result?.choices?.[0]?.text?.trim()))
      .catch((error) => console.log("error", error))
      .finally(() => setIsLoading(false));
  };

  useEffect(() => {
    dispatch(setPageType(PageType.CallCenterRalph));
    dispatch(setPageTitle("Call Center"));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <Popup
        showPopup={visible}
        onClose={() => {
          setVisible(false);
          setIsEnded(false);
          setSummary("");
        }}
        className={styles.popup}
        title="Customer Conversation"
      >
        {isEnded ? (
          <>
            {/* <img
            className={styles.background}
            src={`${BlobBaseUrl}green_bg.png`}
            alt="green background"
          /> */}
            <div className={styles.summaryContainer}>
              <div className={styles.avatar}>
                <h2>Agent</h2>
                {/* <img src={`${BlobBaseUrl}agent_gm.png`} alt="agent" /> */}
                <img
                  src={`${BlobBaseUrl}${currentDemo?.callCenterAgentImage}`}
                  alt="agent"
                />
              </div>
              <div className={styles.summary}>
                <Button onClick={getSummary} className={styles.summaryBtn}>
                  Summarize Conversation
                </Button>
                {isLoading ? (
                  <div className={styles.loaderContainer}>
                    <Loader themeColor="light" />
                  </div>
                ) : (
                  summary && (
                    <div className={styles.conversationContainer}>
                      <h2 style={{ textAlign: "center", marginTop: 10 }}>
                        Powered by Azure OpenAI Services
                      </h2>
                      <TextArea
                        value={summary}
                        onChange={(e) => setSummary(e.value)}
                        autoSize={true}
                        className={styles.textArea}

                        // rows={10}
                      />
                      {/* <p>{summary}</p> */}
                    </div>
                  )
                )}
              </div>
              <div className={styles.avatar}>
                <h2>Customer</h2>
                <img
                  src={`${BlobBaseUrl}${currentDemo?.callCenterCustomerImage}`}
                  alt="customer"
                />
              </div>
              <div className={styles.avatar}>
                <h2>Backend</h2>
                <img
                  src={`${BlobBaseUrl}${currentDemo?.callCenterBackendImage}`}
                  alt="customer"
                />
                {summary && (
                  <Button
                    onClick={() => {
                      setVisible(false);
                      setIsEnded(false);
                      setSummary("");
                    }}
                    className={styles.summaryBtn}
                  >
                    Send to Application
                  </Button>
                )}
              </div>
              <img
                style={{ position: "absolute", bottom: 40 }}
                src={`${BlobBaseUrl}feedback_bar.png`}
                alt="agent"
              />
            </div>
          </>
        ) : (
          <Video
            autoPlay={false}
            src={currentDemo?.callCenterVideoURL}
            pageTitle={"Call Center"}
            pageType={PageType.CallCenterRalph}
            setIsEnded={setIsEnded}
          />
        )}
      </Popup>
    </>
  );
};
